import React from "react";
import { resolveUploadUrl } from "../../utils/apiClient";
import { getInitials } from "../../utils/avatarUtils";
import { useCurrency } from "../../hooks/useCurrency";
import DetailsModal from "../forms/DetailsModal";
import detailStyles from "../forms/DetailsModal.module.css";

export default function EmployeeDetailModal({
  employee,
  activeTab,
  onTabChange,
  isDetailLoading,
  isProjectsLoading,
  assignedProjects,
  onClose,
}) {
  const { format: formatMoney } = useCurrency();

  return (
    <DetailsModal
      title="Employee Details"
      onClose={onClose}
      tabs={[
        { key: 'overview', label: 'Overview' },
        { key: 'projects', label: 'Assigned Projects & Clients' },
      ]}
      activeTab={activeTab}
      onTabChange={onTabChange}
    >
      {activeTab === 'overview' && (
        <>
          <div className={detailStyles.detailSection}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <div style={{
                width: '52px',
                height: '52px',
                borderRadius: '50%',
                background: '#e2e8f0',
                color: '#1f2937',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600,
                fontSize: '1rem',
                overflow: 'hidden',
                flexShrink: 0
              }}>
                {employee.avatar_url ? (
                  <img
                    src={resolveUploadUrl(employee.avatar_url)}
                    alt={employee.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                ) : (
                  getInitials(employee.name)
                )}
              </div>
              <div>
                <div style={{ fontSize: '1rem', fontWeight: 600, color: '#0f172a' }}>
                  {employee.name}
                </div>
                <div style={{ fontSize: '0.85rem', color: '#64748b' }}>
                  {employee.job_title || 'No title'}
                </div>
              </div>
            </div>
          </div>

          {isDetailLoading ? (
            <div style={{ color: '#64748b', fontSize: '0.9rem' }}>Loading employee details...</div>
          ) : (
            <div className={detailStyles.detailSection}>
              <div className={detailStyles.detailRow}>
                <span className={detailStyles.detailLabel}>Email</span>
                <span className={`${detailStyles.detailValue} ${!employee.email ? detailStyles.empty : ''}`}>
                  {employee.email || 'None'}
                </span>
              </div>
              <div className={detailStyles.detailRow}>
                <span className={detailStyles.detailLabel}>Phone</span>
                <span className={`${detailStyles.detailValue} ${!employee.phone_number ? detailStyles.empty : ''}`}>
                  {employee.phone_number || 'None'}
                </span>
              </div>
              <div className={detailStyles.detailRow}>
                <span className={detailStyles.detailLabel}>Type</span>
                <span className={detailStyles.detailValue}>
                  {employee.kind === 'ghost' || employee.status === 'placeholder' ? 'Contractor' : 'Employee'}
                </span>
              </div>
              <div className={detailStyles.detailRow}>
                <span className={detailStyles.detailLabel}>Hourly Rate</span>
                <span className={`${detailStyles.detailValue} ${!employee.default_hourly_rate ? detailStyles.empty : ''}`}>
                  {employee.default_hourly_rate ? `${formatMoney(employee.default_hourly_rate)}/hr` : 'None'}
                </span>
              </div>
            </div>
          )}
        </>
      )}

      {activeTab === 'projects' && (
        <div className={detailStyles.detailSection}>
          {isProjectsLoading ? (
            <div style={{ color: '#64748b', fontSize: '0.9rem' }}>Loading assigned projects...</div>
          ) : assignedProjects.length === 0 ? (
            <div style={{ color: '#64748b', fontSize: '0.9rem' }}>No assigned projects found.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {assignedProjects.map((project) => (
                <div
                  key={project.project_id}
                  style={{
                    border: '1px solid #e2e8f0',
                    borderRadius: '10px',
                    padding: '10px 12px',
                    background: '#ffffff'
                  }}
                >
                  <div style={{ fontSize: '0.92rem', fontWeight: 600, color: '#1f2937' }}>
                    {project.project_name}
                  </div>
                  <div style={{ marginTop: '4px', fontSize: '0.82rem', color: '#64748b' }}>
                    {project.company_name || 'No client company'}
                    {project.client_name ? ` • ${project.client_name}` : ''}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </DetailsModal>
  );
}
